import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26576 11.4998c.086-5.152 4.822-9.663 9.97404-9.491 2.468-.115 4.788.959 6.679 2.468-.807.917-1.642 1.8-2.535 2.626-2.273-1.571-5.505-2.02-7.77804-.205-3.251 2.248-3.399 7.557-.272 9.978 3.04104 2.76 8.79004 1.389 9.63004-2.836-1.905-.029-3.815 0-5.72-.062-.004-1.136-.009-2.273-.004-3.409 3.184-.01 6.369-.014 9.558.01.191 2.673-.162 5.519-1.805 7.729-2.487 3.5-7.481 4.522-11.37704 3.022-3.91-1.489-6.679-5.619-6.35-9.83z",
    fill: "currentColor"
  }));
});